import React from 'react';
import { Check } from 'lucide-react';
import { SOURCE_DEFS } from '../utils/bookingSource';

/**
 * SourceFilter — front-end show/hide chips for booking channels
 * (BookingFlows / GetMyBoat / GetYourGuide). Toggling only filters the VIEW,
 * it never edits bookings or touches the integration connections.
 *
 * Two layouts:
 *  - variant="chips" (default): compact pill row for toolbars (Calendar).
 *  - variant="rows": stacked rows with toggles for filter popovers (Manifest).
 */
const SourceFilter = ({ enabled, onToggle, variant = 'chips', className = '' }) => {
  if (variant === 'rows') {
    return (
      <div className={className} data-testid="source-filter-rows">
        {SOURCE_DEFS.map((s) => {
          const on = enabled.includes(s.key);
          return (
            <button
              key={s.key}
              type="button"
              onClick={() => onToggle(s.key)}
              data-testid={`source-filter-${s.key}`}
              className="w-full flex items-center gap-2.5 rounded-lg px-1 py-1.5 text-left hover:bg-slate-50 transition-colors"
            >
              <img src={s.logo} alt={s.label} className="h-5 w-5 rounded object-contain ring-1 ring-slate-100" />
              <span className={`flex-1 text-sm ${on ? 'text-slate-700' : 'text-slate-400 line-through decoration-slate-300'}`}>
                {s.label}
              </span>
              <span
                className={`h-4.5 w-4.5 min-w-[18px] h-[18px] rounded-md flex items-center justify-center transition-colors ${
                  on ? 'bg-blue-600 text-white' : 'bg-slate-100 text-transparent'
                }`}
              >
                <Check className="w-3 h-3" strokeWidth={3} />
              </span>
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-1.5 flex-wrap ${className}`} data-testid="source-filter-chips">
      {SOURCE_DEFS.map((s) => {
        const on = enabled.includes(s.key);
        return (
          <button
            key={s.key}
            type="button"
            onClick={() => onToggle(s.key)}
            title={on ? `Hide ${s.label} bookings` : `Show ${s.label} bookings`}
            data-testid={`source-filter-${s.key}`}
            className={`inline-flex items-center gap-1.5 h-8 px-2.5 rounded-full text-xs font-medium ring-1 transition-colors ${
              on
                ? 'bg-white text-slate-700 ring-slate-200 hover:bg-slate-50'
                : 'bg-slate-50 text-slate-400 ring-slate-100 hover:text-slate-500'
            }`}
          >
            <img src={s.logo} alt="" className={`h-4 w-4 rounded object-contain ${on ? '' : 'grayscale opacity-50'}`} />
            <span className={on ? '' : 'line-through decoration-slate-300'}>{s.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default SourceFilter;
